import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { Pressable, View } from 'react-native';

export interface PosterStudioFailureAction {
  label: string;
  onPress: () => void;
  /** The one to press: filled, the rest outlined. */
  primary: boolean;
}

/** Why the studio did not open, and what to do: try again, or leave. */
export const PosterStudioFailure = memo(
  ({
    message,
    actions,
  }: {
    message: string;
    actions: PosterStudioFailureAction[];
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          gap: rpx(16),
          padding: rpx(24),
          backgroundColor: aiColors.background,
        }}
      >
        <Typography.Text
          size={rpx(14)}
          color={aiColors.mutedForeground}
          style={{ textAlign: 'center' }}
        >
          {message}
        </Typography.Text>
        <View style={{ flexDirection: 'row', gap: rpx(12) }}>
          {actions.map(action => (
            <Pressable
              key={action.label}
              accessibilityRole="button"
              onPress={action.onPress}
              style={({ pressed }) => ({
                paddingHorizontal: rpx(20),
                paddingVertical: rpx(10),
                borderRadius: rpx(10),
                borderWidth: 1,
                borderColor: action.primary
                  ? aiColors.primary
                  : aiColors.border,
                backgroundColor: action.primary
                  ? aiColors.primary
                  : aiColors.card,
                opacity: pressed ? 0.8 : 1,
              })}
            >
              <Typography.Text
                medium
                size={rpx(14)}
                color={
                  action.primary
                    ? aiColors.primaryForeground
                    : aiColors.foreground
                }
              >
                {action.label}
              </Typography.Text>
            </Pressable>
          ))}
        </View>
      </View>
    );
  },
);
